import styled from "styled-components";
import ButtonCard from 'Components/ButtonCard';
import {
    IconAccounts, IconAdmin, IconCRM, IconDashboard, IconEcomm, IconERP, IconExchange, IconIntel, IconLogistics, IconProcure, IconSettings
} from 'Components/Icons';
import React from 'react';
import { useLocation } from "react-router-dom";
import User from 'Hooks/user';

const menus = [
    { link: '', label: 'Dashboard', icon: IconDashboard, iconSize: 40 },
    { link: 'procurement', label: 'Procurement', icon: IconProcure, iconSize: 45 },
    { link: 'logistics', label: 'Logistics', icon: IconLogistics, iconSize: 50 },
    { link: 'erp', label: 'ERP', icon: IconERP, iconSize: 40 },
    { link: 'crm', label: 'CRM', icon: IconCRM, iconSize: 40 },
    { link: 'wholesale', label: 'Wholesale', icon: IconExchange, iconSize: 40 },
    { link: 'e-comm', label: 'E-comm', icon: IconEcomm, iconSize: 30 },
    { link: 'accounts', label: 'Accounts', icon: IconAccounts, iconSize: 35 },
    { link: 'admin', label: 'Admin', icon: IconAdmin, iconSize: 40 },
    { link: 'settings', label: 'Settings', icon: IconSettings, iconSize: 40 }
]

/**
 * Maps role IDs to the menu links they are allowed to access.
 * Roles not listed here have access to all menus.
 * To restrict a new role: add an entry with its allowed links.
 *
 * Role 8 = Finance, Role 9 = QC
 */
const ROLE_MENUS = {
    8: ['procurement'],
    9: ['procurement'],
}

/** Styled */
const Container = styled.div`
    padding: 0px 50px;
    display: flex;
`
function TemplateMenu(props) {
    const location = useLocation();
    const { userRoles, isMaster, isAdmin } = User();

    const visibleMenus = (() => {
        if (isMaster || isAdmin) return menus;
        const restrictedRoles = userRoles.filter(role => ROLE_MENUS[role]);
        if (restrictedRoles.length === 0) return menus;
        const allowedLinks = new Set(restrictedRoles.flatMap(role => ROLE_MENUS[role]));
        return menus.filter(v => allowedLinks.has(v.link));
    })();

    return (
        <Container>
            {visibleMenus.map(v => {
                const Icon = v.icon
                return <ButtonCard key={`template-menu-key-${v.link}`} title={v.label} link={'/' + v.link} center selected={location.pathname.split('/')[1] === v.link} >
                    <Icon color='#fff' size={v.iconSize} />
                </ButtonCard>
            })}
        </Container>
    )
}

TemplateMenu.propTypes = {

}

export default TemplateMenu

